import { useRouterState } from "@tanstack/react-router";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { BackButton } from "./BackButton";

export function Layout({ children }: { children: React.ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isAdmin = pathname.startsWith("/admin");

  if (isAdmin) {
    // Admin uses its own chrome (sidebar + header). No public navbar/footer.
    return <div className="min-h-screen bg-muted/30">{children}</div>;
  }

  const noFooterPaths = [
    "/login",
    "/signup",
    "/forgot-password",
    "/booking",
    "/business-type",
    "/business-signup",
    "/dashboard",
    "/wallet",
    "/bookings",
    "/profile",
  ];
  const hideFooter = noFooterPaths.some((path) => pathname.startsWith(path));

  return (
    <div className="flex min-h-[100vh] flex-col">
      <Navbar />
      <main className="flex-1 pt-[100px]">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
